export default {
  buttons: {
    cancel: "PERUUTA",
    dismiss: "Sulje",
    add_waypoint: "Lisää määränpää"
  },
  distance: {
    value: "{distance, number, distance} {unit}",
    unit: {
      miles: "maili"
    }
  },
  search: {
    title: "Hae",
    placeholder: "Sijainti",
    enter_location: "Sijainti",
    geolocation: "Käytä sijaintiani",
    help: {
      inactive: "Hae",
      clear: "Pyyhi"
    }
  },
  filters: {
    title: "Filtterit/Hakukriteerit",
    amenities: {
      title: "Palvelut"
    },
    fuels: {
      title: "Polttoaineet"
    }
  },
  directions: {
    title: "Reittisuunnittelu",
    placeholder: {
      destination: "Sijainti",
      waypoint: "Sijainti"
    },
    route: {
      title: "Reittivaihtoehdot",
      avoid_tolls: "Vältä tietulleja",
      avoid_highways: "Vältä moottoriteitä",
      title_corridor: "Poikkeama (max.) reitiltä huoltamolle (km)"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# pv} other {# pv}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# min} other {# min}}\
`,
    button: "Hae"
  },
  locations: {
    title: "Sijainnit",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} Mistä {place}"
  },
  info_window: {
    title: "Osoite",
    location_id: "Huoltamon ID",
    services: "Palvelut",
    nearby: "Läheisyydessä",
    mobile: {
      telephone: "Puhelin"
    },
    opening_hours: {
      title: "Aukioloajat",
      mon: "Ma",
      tue: "Ti",
      wed: "Ke",
      thu: "To",
      fri: "Pe",
      sat: "La",
      sun: "Su",
      open_twentyfourhours: "Avoinna 24h",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      last_updated_on: "Päivitetty viimeksi",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "Reittisuunnittelu"
  },
  amenities: {
    atm: "Pankkiautomaatti",
    cafe: "Café",
    carwash: "Perfect-Autopesu",
    euroshell_card: "Shell-kortit",
    food_offerings: "Ruokatarjonta",
    full_service: "Palvelutankkaus",
    guarded_car_park: "Vartioitu pysäköintiaulue",
    hgv_lane: "Palveleva dieselpiste",
    high_speed_diesel_pump: "High speed dieselmittari",
    mobile_payment: "Mobiilitankkaus",
    parking_lanes: "Pysäköintialue (Truck)",
    partner_loyalty_accepted: "St1-kortit ja muut yhteistyökortit hyväksytään",
    pay_at_pump: "Polttoaineautomaatti",
    restaurant: "Helmisimpukka-Ravintola",
    service_bay: "Autohuolto",
    shell_card: "Shell-kortit",
    shop: "Myymälä",
    shower: "Suihku rahtareille",
    snack_food: "Helmisimpukka-Express",
    standard_toilet: "WC",
    toilet: "WC",
    truck_parking: "Pysäköintialue (Truck)",
    truckport: "Vain Truck-Dieselpiste",
    twenty_four_hour: "Avoinna 24h",
    unmanned: "Automaattiasema",
    vacuum: "Autoimuri sisäpuhdistukseen",
    budgens: "Perävaunun vuokraus",
    wifi: "Wifi",
    vacuum: "Autoimuri",
    fuel_card: "Polttonestekortti",
    credit_card: "Luottokortti",
    air_and_water: "Ilma ja vesi"
  },
  settings: {
    title: "Asetukset",
    tooltip: "Asetukset",
    distance_units: {
      title: "Etäisyys",
      km: "km",
      miles: "maili"
    },
    language: {
      title: "Valitse kieli"
    }
  },
  geolocation: {
    tooltip: "Käytä sijaintiani"
  }
}
